<a (click)="headerSortClicked()" [ngClass]="{'enabled': enabled}">{{label}}<span *ngIf="sortName != null && activeSortName === sortName">{{activeSortDirectionAsc ? ' &uarr;' : ' &darr;'}}</span></a>
